import palette from '.';
import { colorMappings } from './colorMappings';
function getGradient(config, artboardWidth) {
  return config.reduce((accum, currentKey) => {
    const [colorWidth, colorHexValue] = currentKey;
    const fromPercentage = accum.currentPercentage;
    const toPercentage = Math.min(100, accum.currentPercentage + colorWidth / artboardWidth * 100);
    const generateColorString = percentage => `${colorHexValue} ${percentage}%${percentage === 100 ? '' : ','}`;
    return {
      gradientString: `${accum.gradientString}${generateColorString(fromPercentage)}${generateColorString(toPercentage)}`,
      currentPercentage: toPercentage
    };
  }, {
    gradientString: '',
    currentPercentage: 0
  }).gradientString;
}
function generateMBankGradientPercentages() {
  let colorMapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : colorMappings.RETAIL_COLOR_MAPPING;
  const gradientPartWidthToColor = [[379, colorMapping.simpleRed], [42, colorMapping.zeusBlackUI], [388, colorMapping.flushOrange], [253, colorMapping.brightRedUI], [27, colorMapping.endeavourBlueUI], [353, colorMapping.funGreen]];
  return getGradient(gradientPartWidthToColor, 1440);
}
function generateYoungStripe() {
  const gradientPartWidthToColor = [[26.75, palette.electricGreen], [30.01, palette.blue], [4.74, palette.chineseBlack], [26.87, palette.shockingPink], [242.66, palette.blue], [22.81, palette.electricGreen], [21.27, palette.shockingPink]];
  return getGradient(gradientPartWidthToColor, 375);
}
export const gradients = {
  allBrandColorsLinearToRight: `linear-gradient(to right, ${generateMBankGradientPercentages()})`,
  generateAllBrandColorsLinearToRight: function (themeColorMapping) {
    return `linear-gradient(to right, ${generateMBankGradientPercentages(themeColorMapping)})`;
  },
  allBrandColorsLinearToRight30: `
  linear-gradient(
    to right,
    #e41e0a 0,
    #e41e0a 27%,
    #201c17 27%,
    #201c17 32%,
    #f39100 32%,
    #f39100 57%,
    #cc0b18 57%,
    #cc0b18 73%,
    #0077bd 73%,
    #0077bd 77%,
    #18a035 77%,
    #18a035 100%
  );
  `,
  generateButtonRippleBackgroundCircle: function (color) {
    return `radial-gradient(circle, ${color} 10%, transparent 10.01%)`;
  },
  youngBrandColorsToLinearToRight: `linear-gradient(to right, ${generateYoungStripe()})`
};